import * as React from 'react';

const SvgInfoCircle = (props) => (
  <svg
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M8 1.333c-3.666 0-6.666 3-6.666 6.667s3 6.667 6.666 6.667c3.667 0 6.667-3 6.667-6.667s-3-6.667-6.667-6.667Z'
      stroke='var(--colorIconSecondary)'
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M8 10.667V7.333M8.004 5.333h-.006'
      stroke='var(--colorIconSecondary)'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default SvgInfoCircle;
